import React, { Component } from 'react';
import { AlbumStyle } from './platformComp';
import request from 'utils/request';
import { Select, message, Upload, Pagination } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { getCookie, baiduStatistics, imageUrl } from 'utils';
import $ from 'jquery';
import { global } from 'config';

const { Option } = Select;


export default class Album extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mask: false,
            token: JSON.parse(getCookie('token')),
            loading: false,
            introduction: '',
            name: '',
            image: '',
            imgUrl: '',
            sale_status: -1,
            status: 2,
            newA: false,
            flag: true,
            total: 1,
            per_page: 20,
            wait: 1500, // 节流时间，
            is_request: false, // 请求接口开关
            previous: 0, // 上次的执行时间
        }
    }

    componentDidMount() {
        baiduStatistics();
        this.requestList();
    }

    requestList = page => {
        const { token, sale_status, status } = this.state;

        if (sale_status === -1) {
            if (status === 2) {
                request({
                    url: 'huhuapi/Anchor/cateListManager',
                    data: {
                        os: 'pc',
                        sign: token.sign,
                        page: page ? page : 1,
                        // _paginate: 0,
                        // status
                    }
                }).then(res => {
                    // console.log(res.data);
                    if (res.data.status) {
                        this.setState({
                            data: res.data.data.data,
                            total_count: res.data.data.total_count,
                            total: res.data.data.total === 0 ? 1 : res.data.data.total,
                            per_page: res.data.data.per_page
                        });
                    } else {
                        message.error(res.data.errorStr);
                    }
                }).catch(err => console.log(err));
            } else {
                request({
                    url: 'huhuapi/Anchor/cateListManager',
                    data: {
                        os: 'pc',
                        sign: token.sign,
                        page: page ? page : 1,
                        // _paginate: 0,
                        status
                    }
                }).then(res => {
                    // console.log(res.data);
                    if (res.data.status) {
                        this.setState({
                            data: res.data.data.data,
                            total_count: res.data.data.total_count,
                            total: res.data.data.total === 0 ? 1 : res.data.data.total,
                            per_page: res.data.data.per_page
                        });
                    } else {
                        message.error(res.data.errorStr);
                    }
                }).catch(err => console.log(err));
            }

        } else {
            if (status === 2) {
                request({
                    url: 'huhuapi/Anchor/cateListManager',
                    data: {
                        os: 'pc',
                        sign: token.sign,
                        page: page ? page : 1,
                        sale_status
                        // _paginate: 0,
                        // status
                    }
                }).then(res => {
                    // console.log(res.data);
                    if (res.data.status) {
                        this.setState({
                            data: res.data.data.data,
                            total_count: res.data.data.total_count,
                            total: res.data.data.total === 0 ? 1 : res.data.data.total,
                            per_page: res.data.data.per_page
                        });
                    } else {
                        message.error(res.data.errorStr);
                    }
                }).catch(err => console.log(err));
            } else {
                request({
                    url: 'huhuapi/Anchor/cateListManager',
                    data: {
                        os: 'pc',
                        sign: token.sign,
                        page: page ? page : 1,
                        sale_status,
                        status
                    }
                }).then(res => {
                    // console.log(res.data);
                    if (res.data.status) {
                        this.setState({
                            data: res.data.data.data,
                            total_count: res.data.data.total_count,
                            total: res.data.data.total === 0 ? 1 : res.data.data.total,
                            per_page: res.data.data.per_page
                        });
                    } else {
                        message.error(res.data.errorStr);
                    }
                }).catch(err => console.log(err));
            }
        }

    }

    openMask = () => {
        const { total_count } = this.state;

        if (total_count === 0) {
            this.setState({
                newA: true,
                loading: false,
                introduction: '',
                image: '',
                imgUrl: '',
                name: '',
                sale_status1: 1,
                mask: false,
                aduitId: null,
                text: '创建专辑'
            });
            return;
        }
        this.setState({
            loading: false,
            introduction: '',
            image: '',
            imgUrl: '',
            name: '',
            sale_status1: 1,
            mask: true,
            aduitId: null,
            text: '创建专辑'
        });
        $('body').addClass('no-scroll-mask');
    }

    // 创建专辑
    createAlbum = () => {
        const { introduction, name, sale_status1, wait, is_request, previous, image, token, aduitId } = this.state;

        let now = Date.now(); //获得当前时间戳
        if (now - previous > wait) {
            if (is_request) {
                return;
            }

            if (name) {
                if (aduitId) {
                    this.setState({
                        is_request: true
                    });

                    this.changeMask();
                    request({
                        url: 'huhuapi/Anchor/cateEditManager',
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            introduction,
                            name,
                            sale_status: sale_status1,
                            image,
                            id: aduitId
                        }
                    }).then(res => {
                        // console.log(res.data);
                        if (res.data.status) {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            this.requestList();
                            message.success(res.data.data.msg);
                        } else {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            message.warning(res.data.errorStr);
                        }

                    }).catch(err => {
                        this.setState({
                            previous: now,
                            is_request: false
                        });
                        console.log(err);
                    });
                } else {
                    this.setState({
                        is_request: true
                    });

                    this.changeMask();
                    request({
                        url: 'huhuapi/Anchor/cateAddManager',
                        data: {
                            os: 'pc',
                            sign: token.sign,
                            introduction,
                            name,
                            sale_status: sale_status1,
                            image
                        }
                    }).then(res => {
                        // console.log(res.data);
                        if (res.data.status) {
                            this.setState({
                                previous: now,
                                is_request: false
                            });

                            this.requestList();
                            message.success(res.data.data.msg);
                        } else {
                            this.setState({
                                previous: now,
                                is_request: false
                            });
                            message.warning(res.data.errorStr);
                        }

                    }).catch(err => {
                        this.setState({
                            previous: now,
                            is_request: false
                        });
                        console.log(err);
                    });
                }

            } else {
                this.setState({
                    previous: now,
                    is_request: false
                });

                message.error('请完善专辑信息');
            }
        }
    }

    // 
    handleChange = value => {
        const { mask } = this.state;

        // console.log(value);
        switch (value) {
            case 'puton':
                this.setState({
                    sale_status: 1
                }, () => {
                    if (!mask) this.requestList();
                });
                break;
            case 'pullof':
                this.setState({
                    sale_status: 0
                }, () => {
                    if (!mask) this.requestList();
                });
                break;
            case 'all':
                this.setState({
                    sale_status: -1
                }, () => {
                    this.requestList();
                });
                break;
            case 'progress':
                this.setState({
                    status: 0
                }, () => {
                    this.requestList();
                });
                break;
            case 'failed':
                this.setState({
                    status: -2
                }, () => {
                    this.requestList();
                });
                break;
            case 'successed':
                this.setState({
                    status: 1
                }, () => {
                    this.requestList();
                });
                break;
            case 'all2':
                this.setState({
                    status: 2
                }, () => {
                    this.requestList();
                });
                break;
            default:
                break;
        }
    }

    handleChange1 = value => {
        // console.log(value);
        switch (value) {
            case 'puton':
                this.setState({
                    sale_status1: 1
                });
                break;
            case 'pullof':
                this.setState({
                    sale_status1: 0
                });
                break;

            default:
                break;
        }
    }

    // 遮罩
    changeMask = () => {
        const { mask } = this.state;

        this.setState({
            mask: !mask
        });
        if (mask) {
            $('body').removeClass('no-scroll-mask');
        } else {
            $('body').addClass('no-scroll-mask');
        }
    }

    changeNew = () => {
        const { newA } = this.state;

        this.setState({
            newA: !newA
        });
    }

    changeFlag = () => {
        const { flag } = this.state;

        this.setState({
            flag: !flag
        });
    }

    // 渲染专辑列表
    renderList = () => {
        const { data } = this.state;

        let status = {
            '0': '审核中',
            '1': '审核成功',
            '-2': '审核失败'
        }

        let sale_status = {
            '0': '下架',
            '1': '上架 ',
        }

        let colors = {
            '0': '#28B6FF',
            '-2': '#FF4D4D',
            '1': '#44D7B6'
        }

        let arr;
        if (data) {
            if (data.length < 6 && data.length > 0) {
                arr = [].concat(data);
                for (let i = 0; i < 6 - data.length; i++) {
                    arr.push({});
                }

                return arr.map((item, index) => <div key={index} className="album-item" style={{ background: index % 2 === 1 ? 'rgba(248,249,251,1)' : 'rgba(252,253,255,1)', borderTop: '.5px solid #dcdcdc' }}>
                    <div className="item" style={{ width: '26%' }}>{item.name}</div>
                    <div className="item" style={{ width: '21%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }} >
                        {item.image_show && <img style={{ width: '80px', height: '80px', borderRadius: '14px' }} alt="" src={imageUrl(item.image_show)} />}
                    </div>
                    <div className="item" style={{ width: '21%' }}>{item.update_time ? item.update_time : item.create_time}</div>
                    <div className="item" style={{ width: '10%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{sale_status[item.sale_status]}</div>
                    <div className="item" style={{ width: '10%', borderRight: '.5px solid #dcdcdc', color: colors[item.status] }}>{status[item.status]}</div>
                    {item.name ? <div className="item eeee" style={{ width: '12%', cursor: 'pointer' }} onClick={() => this.aduit(item)}>编辑</div> : <div className="item" style={{ width: '12%' }}></div>}
                </div>);
            } else if (data.length >= 6) {
                arr = data;
                return arr.map((item, index) => <div key={index} className="album-item" style={{ background: index % 2 === 1 ? 'rgba(248,249,251,1)' : 'rgba(252,253,255,1)', borderTop: '.5px solid #dcdcdc' }}>
                    <div className="item" style={{ width: '26%' }}>{item.name}</div>
                    <div className="item" style={{ width: '21%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }} >
                        {item.image_show && <img style={{ width: '80px', height: '80px', borderRadius: '14px' }} alt="" src={imageUrl(item.image_show)} />}
                    </div>
                    <div className="item" style={{ width: '21%' }}>{item.update_time ? item.update_time : item.create_time}</div>
                    <div className="item" style={{ width: '10%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc' }}>{sale_status[item.sale_status]}</div>
                    <div className="item" style={{ width: '10%', borderRight: '.5px solid #dcdcdc', color: colors[item.status] }}>{status[item.status]}</div>
                    <div className="item eeee" style={{ width: '12%', cursor: 'pointer' }} onClick={() => this.aduit(item)}>编辑</div>
                </div>);
            } else {
                return <div className="program-empty" style={{ borderTop: '.5px solid #dcdcdc' }}>
                    <img src={require('images/platform/empty.png')} className="empty" alt="" />
                    <div className="text">暂时没有专辑</div>
                </div>
            }
        }
    }

    // 编辑
    aduit = item => {
        this.setState({
            loading: false,
            introduction: item.introduction,
            image: item.image,
            imgUrl: imageUrl(item.image),
            name: item.name,
            mask: true,
            aduitId: item.id,
            text: '编辑专辑',
            sale_status1: item.sale_status,
        });
        $('body').addClass('no-scroll-mask');
    }


    // 限制图片大小
    beforeUpload = file => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('仅支持png/jpg的图片!');
        }
        const isLt2M = file.size / 1024 <= 300;
        if (!isLt2M) {
            message.error('仅支持300k以内的图片!');
        }
        return isJpgOrPng && isLt2M;
    }

    // 上传事件
    sendImage = info => {
        // console.log(info);
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info);
            if (info.file.response) {
                if (info.file.response.status) {
                    this.setState({
                        imgUrl: imageUrl(info.file.response.msg.file_url),
                        image: info.file.response.msg.save_path,
                        loading: false
                    });
                    message.success('上传成功');
                } else {
                    message.error(info.file.response.msg);
                }

            }

        }
    };

    // 受控组件
    write = key => e => {
        this.setState({
            [key]: e.target.value,
        });
    }

    skipPage = val => {
        // console.log(val);

        this.requestList(val);
    }

    render() {
        const { mask, imgUrl, text, name, introduction, sale_status1, newA, flag, total, per_page } = this.state;
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">选择图片</div>
            </div>
        );


        return (<AlbumStyle>
            <div className="album-kfpt">
                <header className="album-header">
                    <div className="header-title">发布状态</div>
                    <Select defaultValue="all" style={{ width: 100 }} onChange={this.handleChange}>
                        <Option value="all">全部</Option>
                        <Option value="puton">上架</Option>
                        <Option value="pullof">下架</Option>
                    </Select>
                    <div className="header-title">审核状态</div>
                    <Select defaultValue="all2" style={{ width: 120 }} onChange={this.handleChange}>
                        <Option value="all2">全部</Option>
                        <Option value="progress">审核中</Option>
                        <Option value="failed">审核失败</Option>
                        <Option value="successed">审核成功</Option>
                    </Select>
                    <div className="create-ablum" onClick={this.openMask}>创建专辑</div>
                </header>
                <div className="album-main">
                    <div className="tabs">
                        <div style={{ width: '26%', fontWeight: 'bold' }}>专辑名字</div>
                        <div style={{ width: '21%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>封面</div>
                        <div style={{ width: '21%', fontWeight: 'bold' }}>发布时间</div>
                        <div style={{ width: '10%', borderLeft: '.5px solid #dcdcdc', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>发布状态</div>
                        <div style={{ width: '10%', borderRight: '.5px solid #dcdcdc', fontWeight: 'bold' }}>审核状态</div>
                        <div style={{ width: '12%', fontWeight: 'bold' }}>操作</div>
                    </div>
                    <div className="album-list">
                        {this.renderList()}
                    </div>
                </div>
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Pagination defaultCurrent={1} total={total} pageSize={per_page} onChange={this.skipPage} showSizeChanger={false} />
                </div>
            </div>

            {mask && <div className="mask">
                <div className="mask-con">
                    <div className="mask-title">{text}</div>
                    <div className="mask-name">
                        <div className="mask-lab">专辑名字</div>
                        <input className="t2" placeholder="最多填写14个字" maxLength="14" value={name} onChange={(e) => this.write('name')(e)} />
                        <span>*</span>
                    </div>
                    <div className="mask-intro">
                        <div className="mask-lab">专辑简介</div>
                        <textarea className="t4" maxLength="50" placeholder="最多填写50个字" value={introduction} onChange={(e) => this.write('introduction')(e)}></textarea>
                    </div>
                    <div className="mask-cover">
                        <div className="mask-lab">专辑封面</div>
                        <Upload
                            name="file"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action={global.domain + "huhuapi/files/upload_image"}
                            // beforeUpload={this.beforeUpload}
                            onChange={this.sendImage}
                        >
                            {imgUrl ? <img src={imgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    </div>
                    <div className="mask-tip">请上传1M以内的文件，支持JPG、PNG格式。建议上传尺寸为500px*500px的图片。</div>
                    <div className="mask-release">
                        <div className="mask-lab">发布状态</div>
                        <Select defaultValue={sale_status1 === 1 ? "puton" : "pullof"} style={{ width: 100 }} onChange={this.handleChange1}>
                            <Option value="puton">上架</Option>
                            <Option value="pullof">下架</Option>
                        </Select>
                    </div>
                    <div className="mask-btns">
                        <div className="btn1" onClick={this.createAlbum}>确定</div>
                        <div className="btn2" onClick={this.changeMask}>取消</div>
                    </div>
                </div>
            </div>}

            {newA && <div className="firstmask">
                <div className="firstmask-con">
                    <img alt="" src={require('images/platform/mask.png')} className="firstmask-img" />
                    <div className="firstmask-title">提示</div>
                    {/* <div className="firstmask-text1">同意主播协议后才能创建专辑</div> */}
                    <div className="firstmask-text2">
                        <img className="firstmask-agree" onClick={this.changeFlag} style={{ border: flag ? 0 : '' }} src={flag ? require('images/platform/agree.png') : ''} alt="" />
                        <div className="firstmask-text3">我已同意<a href={global.href + "simple/anchor"} target="_blank" rel="noopener noreferrer">《呼呼收音机主播协议》</a></div>
                    </div>

                    <div className="firstmask-btns">
                        <div className="firstmask-btn1" onClick={this.changeNew}>取消</div>
                        <div className="firstmask-btn2" onClick={() => { this.changeNew(); this.changeMask(); }}>确定并创建</div>
                    </div>
                </div>
            </div>}
        </AlbumStyle>);
    }
}